/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { CreditAppSavedSectionInfo } from '../../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveOutsourcedAccountant_updateCreditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null };

export type RemoveOutsourcedAccountant_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type RemoveOutsourcedAccountant_updateCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly hasOutsourcedAccountant: boolean | null, readonly outsourcedAccountant: RemoveOutsourcedAccountant_updateCreditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null, readonly savedSectionsInfo: ReadonlyArray<RemoveOutsourcedAccountant_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type RemoveOutsourcedAccountant_Mutation = { readonly __typename: 'Mutation', readonly updateCreditApplication: RemoveOutsourcedAccountant_updateCreditApplication_CreditApplication };


export type RemoveOutsourcedAccountantVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  hasOutsourcedAccountant?: _Types.InputMaybe<_Types.Scalars['Boolean']['input']>;
  outsourcedAccountant?: _Types.InputMaybe<_Types.PersonInput>;
}>;


export type RemoveOutsourcedAccountant = RemoveOutsourcedAccountant_Mutation;


export const RemoveOutsourcedAccountantDocument = gql`
    mutation RemoveOutsourcedAccountant($creditApplicationId: ID!, $hasOutsourcedAccountant: Boolean, $outsourcedAccountant: PersonInput) {
  updateCreditApplication(
    creditApplicationId: $creditApplicationId
    hasOutsourcedAccountant: $hasOutsourcedAccountant
    outsourcedAccountant: $outsourcedAccountant
  ) {
    salesforceCreditId
    fetchedAt
    hasOutsourcedAccountant
    outsourcedAccountant {
      id
      firstName
      lastName
      email
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${CreditAppSavedSectionInfo}`;
export type RemoveOutsourcedAccountantMutationFn = Apollo.MutationFunction<RemoveOutsourcedAccountant, RemoveOutsourcedAccountantVariables>;

/**
 * __useRemoveOutsourcedAccountant__
 *
 * To run a mutation, you first call `useRemoveOutsourcedAccountant` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOutsourcedAccountant` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOutsourcedAccountant, { data, loading, error }] = useRemoveOutsourcedAccountant({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      hasOutsourcedAccountant: // value for 'hasOutsourcedAccountant'
 *      outsourcedAccountant: // value for 'outsourcedAccountant'
 *   },
 * });
 */
export function useRemoveOutsourcedAccountant(baseOptions?: Apollo.MutationHookOptions<RemoveOutsourcedAccountant, RemoveOutsourcedAccountantVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOutsourcedAccountant, RemoveOutsourcedAccountantVariables>(RemoveOutsourcedAccountantDocument, options);
      }
export type RemoveOutsourcedAccountantHookResult = ReturnType<typeof useRemoveOutsourcedAccountant>;
export type RemoveOutsourcedAccountantMutationResult = Apollo.MutationResult<RemoveOutsourcedAccountant>;
export type RemoveOutsourcedAccountantMutationOptions = Apollo.BaseMutationOptions<RemoveOutsourcedAccountant, RemoveOutsourcedAccountantVariables>;